module.exports = __webpack_public_path__ + "img/pricing-information-clouds.0ab8bcfa.png";